import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Crud, CrudService, CustomHttp, ConfigServerService } from '../../../core';
import { Feriado } from '../feriado';
import { FeriadoFilter } from '../filter';

@Injectable({
    providedIn: 'root'
})
export class FeriadoCrudHttpService implements Crud<Feriado> {
    resource = 'feriado';
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private crudService: CrudService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/${this.resource}`;
    }

    /** Pesquisa todos os feriados cadastrados */
    search(): Observable<Feriado[]> {
        return this.crudService.search<Feriado>(this.resource);
    }

    searchWithFilter(filter: FeriadoFilter): Observable<Feriado[]> {
        // Params
        let params: HttpParams;
        // Filter params
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<Feriado[]>(this.pathApi, {params});
    }

    /** Procura um único feriado através do seu ID */
    find(id: number): Observable<Feriado> {
        return this.crudService.find<Feriado>(this.resource, id);
    }

    /** Carrega um único feriado através do seu ID */
    load(id: number): Observable<Feriado> {
        return this.crudService.load<Feriado>(this.resource, id);
    }

    /** Insere um novo feriado */
    insert(entity: Feriado): Observable<Feriado> {
        return this.crudService.insert<Feriado>(this.resource, entity);
    }

    /** Altera um feriado existente */
    update(entity: Feriado): Observable<Feriado> {
        return this.crudService.update<Feriado>(this.resource, entity);
    }

    /** Exclui um feriado através do seu ID */
    delete(id: number): Observable<string> {
        return this.crudService.delete(this.resource, id);
    }
}
